module.exports = __webpack_public_path__ + "img/home-10.2a35f477.webp";